
import { getRoleToPageAccess } from "./apiService";
const getDefaultReport = async () => {
  try {
    const reportData = await getRoleToPageAccess();

    const targetDashboardName = "Advance Metering Report";
    const dashboardEntry = reportData.find(
      (d) => d.dashboard === targetDashboardName
    );

    console.log(dashboardEntry, " dashboard Entry ....")
    if (!dashboardEntry || !dashboardEntry.pages?.length) {
      return {
        dashboard: targetDashboardName,
        report: "",
        page: ""
      };
    }

    const firstPage = dashboardEntry.pages[0];

    return {
      dashboard: dashboardEntry.dashboard,  // "Advance Metering Report"
      report: dashboardEntry.report,        // e.g. "Meter Traceability"
      page: firstPage.page_name             // e.g. "WFM vs HES vs MDM"
    };
  } catch (error) {
    console.error("Error fetching default report:", error);
    return {
      dashboard: "Advance Metering Report",
      report: "",
      page: ""
    };
  }
};

export default getDefaultReport;
